export const environment = { 
  production: false,
  env: 'STAGE',
  serverUrl: 'https://api.anu-abbv.stagging.zsservices.com/',
  idmLogOutUrl: 'https://javelin.staging.zsservices.com/abbvie/IdentityManager-SSO/app/Web/logout.aspx',
  idmLogInUrl: 'https://javelin.staging.zsservices.com/abbvie/IdentityManager-SSO/app/Web/login.aspx'
};
